export var Language;
(function (Language) {
    Language["ENGLISH"] = "en";
    Language["SPANISH"] = "es";
})(Language || (Language = {}));
